var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.status == 1 ? 'bgc-sgreenone c-greenfour' : ''},[_vm._v(" "+_vm._s(_vm.status == 1 ? 'CONTA PRINCIPAL' : '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }